import { isDefined } from '@follow/cdk'
import getApi from '../../api'
import { HealthData, HealthDataPayload } from '../../model/HealthData'
import { serializePatientHealthData } from './mapper/patientHealthData.mapper'

export const createPatientHealthData = (patientId: string, healthData: Partial<HealthData>[]) =>
  getApi().post<HealthDataPayload>(`patients/${patientId}/module_data/batch`, {
    moduleData: healthData.filter(isDefined).map(serializePatientHealthData),
  })
